
import { useI18n } from "vue-i18n";
import { defineComponent, ref, reactive, watch, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import defray from "@/api/defray";
import { baseURL } from "@/api/index";
import Realtime from "@/utils/realtime";
import Crypto from "./crypto.vue";
import Fiat from "./fiat.vue";
import { Popover, DropdownMenu, DropdownItem, Toast, Loading, Icon } from "vant";
export default defineComponent({
  name: "defray",
  components: {
    [Popover.name]: Popover,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    Crypto,
    Fiat
  },
  setup() {
    const BASE_URL = process.env.BASE_URL;
    const route = useRoute();
    const { t, locale } = useI18n();
    const { lang } = route.query;
    const dev = process.env.VUE_APP_BUILD_ENV;
    const showPopover = ref(false);
    const currentLang = ref();
    const data = reactive({
      langs: [
        { text: "简体中文", value: "cn" },
        { text: "English", value: "en" }
      ]
    });
    const types = ref(-1);
    const showCrypto = ref(false);
    const showFiat = ref(false);

    currentLang.value = lang ?? "en";
    watch(
      currentLang,
      newLang => {
        locale.value = newLang;
      },
      {
        immediate: true
      }
    );

    const convertLangName = computed(() => {
      return (
        data.langs.find(x => {
          return x.value === locale.value;
        })?.text || ""
      );
    });

    const changeLang = item => {
      locale.value = item.value;
    };

    // @ts-ignore
    const k: string = route.query?.k || "";
    onMounted(() => {
      if (!k) {
        Toast({
          message: t("error"),
          overlay: false,
          duration: 2000
        });
        return;
      }
      getOrderDetail();
    });

    const info = ref({});
    const getOrderDetail = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading",
        overlay: true,
        duration: 0,
        overlayStyle: {
          backgroundColor: "rgba(0, 0, 0, 0)"
        }
      });
      const res = await defray.getPayIn();
      loadingToast?.close();
      if (res?.code == 200) {
        info.value = res;
        if (res?.data?.crypto_currency_config_list?.length) {
          showCrypto.value = true;
        }
        if (res?.data?.cash_currency_config_list?.length) {
          showFiat.value = true;
        }

        if (res?.data?.crypto_order_detail) {
          types.value = 0;
          return;
        }

        if (res?.data?.cash_order_detail) {
          types.value = 1;
          return;
        }

        if (types.value == -1) {
          if (showCrypto.value) {
            types.value = 0;
          } else if (showFiat.value) {
            types.value = 1;
          }
          RefRate();
        }

        // ListenerOrderStatus(res?.data?.out_order_no);
      } else {
        res?.message &&
          Toast({
            message: res?.message,
            overlay: false,
            duration: 2000
          });
      }
    };

    // const ListenerOrderStatus = id => {
    //   const RealtimePush = Realtime.initRealtimePush(`${baseURL}ws/orders/${id}`, { id });
    //   if (RealtimePush) {
    //     RealtimePush.onmessage = event => {
    //       console.log("收到消息: " + event.data);
    //     };
    //   }
    // };

    const time = ref(10);
    const refresh = ref(false);
    let timer = 0;
    const RefRate = () => {
      timer = setInterval(async () => {
        if (time.value == 0) {
          clearRefRate();
          refresh.value = true;
          const res = await defray.getPayIn();
          refresh.value = false;
          if (res?.code == 200) {
            time.value = 10;
            RefRate();
          }
        } else {
          time.value--;
        }
      }, 1000);
    };

    const clearRefRate = () => {
      timer && window.clearInterval(timer);
      timer = 0;
    };

    return {
      BASE_URL,
      dev,
      convertLangName,
      currentLang,
      showPopover,
      changeLang,

      info,
      showCrypto,
      showFiat,

      data,
      types,

      time,
      refresh,
      clearRefRate
    };
  }
});
